import { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-regular-svg-icons";

export default function ProductCard({ product, onClick, onSelect, isSelected }) {
    const settingsPills = useMemo(() => {
        if (!product.settings) return [];
        const pills = [];
        const shouldShow = (value) => {
            if (!value) return false;
            const lower = value.toLowerCase().trim();
            return lower !== "no" && lower !== "no colouring" && lower !== "no polishing";
        };
        if (product.settings.application) pills.push(product.settings.application);
        if (product.settings.material) pills.push(product.settings.material);
        if (shouldShow(product.settings.color)) pills.push(product.settings.color);
        if (shouldShow(product.settings.polish)) pills.push(product.settings.polish);
        if (shouldShow(product.settings.coating)) pills.push(product.settings.coating);
        return pills;
    }, [product.settings]);

    const previewSrc = useMemo(() => {
        if (product.preview_image) {
            return product.preview_image;
        }
        return null;
    }, [product.preview_image]);

    const handleCardClick = () => {
        if (onClick) onClick(product);
    };

    const handleCheckboxClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (onSelect) onSelect(product.id);
    };

    const handleCheckboxMouseDown = (e) => {
        e.preventDefault();
    };

    return (
        <div className={`product-card ${isSelected ? "selected" : ""}`} onClick={handleCardClick}>
            <div className="product-card-preview">
                {previewSrc ? (
                    <img src={previewSrc} alt={product.name} draggable={false} />
                ) : (
                    <div className="product-card-no-preview">3D</div>
                )}
                <div
                    className="product-card-checkbox"
                    onClick={handleCheckboxClick}
                    onMouseDown={handleCheckboxMouseDown}
                >
                    <input type="checkbox" checked={isSelected} readOnly />
                    <span className="product-card-checkbox-mark" />
                </div>
            </div>

            <div className="product-card-info">
                <h4 className="product-card-name">{product.name}</h4>
                <div className="product-card-labels">
                    {product.labels &&
                        product.labels.map((label) => (
                            <span
                                key={label.id}
                                className="product-card-label-chip"
                                style={label.color ? { backgroundColor: label.color } : {}}
                            >
                                {label.name}
                            </span>
                        ))}
                </div>
                {settingsPills.length > 0 && (
                    <div className="product-card-settings-pills">
                        {settingsPills.map((pill, i) => (
                            <span key={i} className="product-card-setting-pill">
                                {pill}
                            </span>
                        ))}
                    </div>
                )}
                <div className="product-card-price-row">
                    {product.has_fixed_price && product.price != null && (
                        <p className="product-card-price">€{Number(product.price).toFixed(2)}</p>
                    )}
                    <p className="product-card-quantity">{product.default_quantity} pcs</p>
                </div>
            </div>

            <div className="product-card-edit-overlay" aria-hidden="true">
                <span className="product-card-edit-icon">
                    <FontAwesomeIcon icon={faPencil} />
                </span>
            </div>
        </div>
    );
}
